import styled from "styled-components";

export default styled.div<{ showEnvBanner?: boolean }>`
  position: fixed;
  top: ${({ showEnvBanner }) => (showEnvBanner ? "60px;" : "0;")};
  left: 0;
  width: 100vw;
  height: ${({ showEnvBanner }) => (showEnvBanner ? "calc(100vh - 60px);" : "100vh;")};

  background-color: ${({ theme }) => theme.deprecatedColors.background};
  z-index: 1;
  overflow: scroll;
  overflow-x: hidden;
`;
